export const logo = [
    '220 32',
    `<g>
    <text x="50%" y="50%"
      text-anchor="middle"
      dominant-baseline="middle"
      font-family="Segoe UI, Segoe UI Light, Arial, sans-serif"
      font-size="20"
      font-weight="bold"
      fill="white">
      Master Data Loader
    </text>
  </g>`
];
